const initialState = {}

export default function docs(state = initialState, action) {
    switch (action.type) {
        case 'LOAD_DOCS_SUCCESS':
            const newState = {}

            for (const item of action.data) {
                newState[item.slug] = item
            }

            return newState

        case 'LOAD_SINGLE_DOC_SUCCESS':
            return {
                ...state,
                [action.data.slug]: action.data,
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./app/reducers/docs.js